// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"f61233fa","316":"ba529c90","573":"f242ac6f","870":"2c74dd30","947":"b95c5aef"}[chunkId] + ".chunk.css";
};